import { useState } from 'react';

import { MostPreferredThemeCategoriesViewModel } from '@api/v3';

import { Wrapper, Tab } from './styled';
import { Props } from './types';

const FilterTabs = ({
  tabs,
  defaultSelectedTabKey,
  onTabSelected,
  items,
}: Props) => {
  const [selectedTabKey, setSelectedTabKey] = useState<string>(
    defaultSelectedTabKey
  );

  const handleSelectedTab = (key: string) => {
    setSelectedTabKey(key);
    onTabSelected?.(key);
  };
  const renderTabItem = (tab: MostPreferredThemeCategoriesViewModel) => {
    const tabItemObjectExists = items?.find((items) => {
      return items?.category === tab?.title;
    });
    if (tabItemObjectExists) {
      return (
        <Tab
          key={tab.title}
          active={tab.title === selectedTabKey}
          onClick={() => handleSelectedTab(tab.title ?? '')}
          aria-label={tab.title}
        >
          {tab?.title}
        </Tab>
      );
    }
  };

  return (
    <Wrapper>
      {tabs?.map((item) => {
        return renderTabItem(item);
      })}
    </Wrapper>
  );
};

export default FilterTabs;
